import { render, staticRenderFns } from "./CompanyBankAccountsView.vue?vue&type=template&id=2a90fe6a&"
import script from "./CompanyBankAccountsView.vue?vue&type=script&lang=js&"
export * from "./CompanyBankAccountsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports